module.exports = {
  webConfig: process.env.webConfig,
  gatewayAlb: process.env.webConfig,
  matchboxAlb: process.env.matchboxAlb,
  jpushWssUrl: process.env.jpushWssUrl,
  redis: {
    'write': {
      'port': process.env.redisWrite && process.env.redisWrite.split(':')[1],
      'host': process.env.redisWrite && process.env.redisWrite.split(':')[0],
    },
    'read': {
      'port': process.env.redisRead && process.env.redisRead.split(':')[1],
      'host': process.env.redisRead && process.env.redisRead.split(':')[0],
    },
  },
  cdn: process.env.cdn,
  mktdataWssUrl: `${process.env.mktdataWssUrl}/ws`,
  marginWssUrl: process.env.marginWssUrl,
  recapchaSitekey: process.env.recapchaSitekey,
  logUrl: process.env.logUrl,
  i18nPath: `${process.env.i18nPath}/i18n/api/v1/out`,
  siteUrl: process.env.siteHost,
  accountsUrl: process.env.accountsUrl,
  inmailWssUrl: `${process.env.inmailWssUrl}/ws/inbox_`,
  siteApiHost: process.env.siteApiHost,
};
